import { getUuid } from '@/utils/api';
import { useStore } from '@/utils/vue-api';
import { inject, computed } from 'vue';

export const useFlowX = () => {
	const store = useStore();
	const templateMenus = inject('TEMPLATE_MENUS', []);
	const getTemplateMenus = computed(() => templateMenus?.value || []);

	const composeFlowXMenu = (originMenus = []) => {
		const menus = originMenus
			.map((menu, index) => {
				menu.id = menu.id || getUuid();
				menu.sort = typeof menu.sort !== 'undefined' ? menu.sort : index + 1;
				const updatedModules = (menu.moduleVOS || []).map((module, moduleIdx) => ({
					...module,
					sort: typeof module.sort !== 'undefined' ? module.sort : moduleIdx + 1
				}));
				menu.moduleVOS = updatedModules.sort((a, b) => a.sort - b.sort);
				return menu;
			})
			.filter(menu => {
				// 过滤掉无意义的菜单项：0菜单 1模块
				if (menu.menuType === 0 && !menu.moduleVOS?.length) return false;
				return true;
			})
			.sort((a, b) => a.sort - b.sort);

		if (menus.length >= 1) {
			// 将第一个菜单项强制对准为「首页菜单」
			menus[0].isHome = true;
		}

		return menus;
	};

	const findAnotherMenu = (menu, moduleId) => {
		if (!menu || !moduleId) return null;

		const menus = getTemplateMenus.value;
		const allModules = store.getters.getPageAllModules;
		const anotherModules = allModules.filter(item => item.menuId !== menu.id && item.moduleId === moduleId);

		if (anotherModules.length > 0) {
			// 如果在首页外的菜单匹配到相同模块 则直接跳转至对应菜单位置
			// PS: 已经限制了相同组件最多被订阅两次
			const anotherMenuId = anotherModules[0]?.menuId;
			const anotherTargetMenu = menus.find(item => item.id === anotherMenuId);
			// 跳过首页菜单
			if (anotherTargetMenu.isHome) return menu;
			return anotherTargetMenu;
		}
		return menu;
	};

	return {
		composeFlowXMenu,
		findAnotherMenu
	};
};
